import { render, staticRenderFns } from "./Prefix-&-Suffix-Stacking.md?vue&type=template&id=e04be6fc&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports